import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { Icon as a } from "../../../../components/Icon/index.js";
import { CommentBadgeType as r } from "../../types.js";
import { TipBadgeContainer as m, TopBadgeContainer as p } from "./style.js";
import { Lightbulb as d, Star as g } from "@pelando/fontawesome/icons";
import { useTranslation as i } from "../../../../hooks/useTranslation/index.js";
function c({ className: t }) {
  const { t: o } = i("common");
  return /* @__PURE__ */ n(m, { className: t, children: [
    /* @__PURE__ */ e(a, { icon: d, "aria-label": o("tip-badge-aria-label") }),
    o("tip-badge-text")
  ] });
}
function l({ className: t }) {
  const { t: o } = i("common");
  return /* @__PURE__ */ n(p, { className: t, children: [
    /* @__PURE__ */ e(a, { icon: g, "aria-label": o("top-badge-aria-label") }),
    o("top-badge-text")
  ] });
}
function b({ type: t, className: o }) {
  return {
    [r.TIP]: /* @__PURE__ */ e(c, { className: o }),
    [r.TOP]: /* @__PURE__ */ e(l, { className: o })
  }[t];
}
function h({ type: t, className: o }) {
  return /* @__PURE__ */ e(b, { type: t, className: o });
}
export {
  b as BadgeByType,
  h as CommentBadge,
  c as TipBadge,
  l as TopBadge
};
